import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledHintContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledPasswordHint = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  column-gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXs}px;
  display: flex;
  align-items: center;

  &.hint-success {
    color: ${({ theme }) => theme.semantic.SuccessDefault};

    path {
      fill: ${({ theme }) => theme.semantic.SuccessDefault};
    }
  }

  &.hint-error {
    color: ${({ theme }) => theme.semantic.ErrorDefault};

    path {
      fill: ${({ theme }) => theme.semantic.ErrorDefault};
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
